import SafeRenderHtml from 'CampaignVolunteer/components/SafeRenderHtml'
import ExpressButtons from './ExpressButtons'

export default function DonatePage({
  config,
  isMonthly,
  setIsMonthly,
  amount,
  setAmount,
  coverFee,
  setCoverFee,
  coverFeeAmount,
  paymentAmount,
  handleSubmit,
  presetAmounts,
  stripePromise,
  onComplete
}) {
  const displayAmount = (val) => val % 100 === 0 ?
    (val / 100).toFixed(0) :
    (val / 100).toFixed(2);

  const [customInputAmount, setCustomInputAmount] = useState((amount / 100).toFixed(amount % 100 === 0 ? 0 : 2));
  const [animateHeart, setAnimateHeart] = useState(false); // State to trigger heart animation

  function handleInputChange(e) {
    const val = e.target.value.replace(/[^0-9.]/g, '');
    setCustomInputAmount(val);

    let parsedValue = parseFloat(val);
    if (isNaN(parsedValue)) parsedValue = 0;

    const rounded = Math.round((parsedValue + Number.EPSILON) * 100) / 100;

    setAmount(Math.round(rounded * 100));
  }

  const [showDisabledMesasge, setShowDisabledMessage] = useState(false);
  const buttonDisabled = !paymentAmount || paymentAmount < 50 // minimum 50 minor units

  useEffect(() => {
    // 1.5 second timeout to show the disabled message
    if (buttonDisabled) {
      const timeout = setTimeout(() => {
        setShowDisabledMessage(true);
      }
      , 1500);
      return () => {
        clearTimeout(timeout);
        setShowDisabledMessage(false);
      }
    }
    setShowDisabledMessage(false);
  }, [buttonDisabled])

  // Update custom input amount when amount changes
  useEffect(() => {
    if (amount / 100 == parseFloat(customInputAmount)) return; // Prevent loop of custom setting amount setting custom and e.g. jumping from 2.1 to 2.10
    setCustomInputAmount((amount / 100).toFixed(amount % 100 === 0 ? 0 : 2));
  }, [amount]);

  useEffect(() => {
    if (isMonthly) {
      setAnimateHeart(true); // Trigger the animation when monthly is selected
    }
    if(!isMonthly && !config.preTickCoverFee) {
      setCoverFee(false); // Reset cover fee when switching to one-off if not pre-ticked
    }
  }, [isMonthly]);

  useEffect(() => {
    if (animateHeart) {
      const timeout = setTimeout(() => setAnimateHeart(false), 1000); // Match animation duration
      return () => clearTimeout(timeout);
    }
  }, [animateHeart]);

  const coverFeeText = useMemo(() => config.coverFeeText.replace(/{{( ?)fee( ?)}}/g, '£' + displayAmount(coverFeeAmount)), [config.coverFeeText, coverFeeAmount]);

  function AmountButton({ value }) {
    return (
      <button
        className={`amount-btn ${amount === value ? 'active' : ''}`}
        type="button"
        onClick={() => {
          setAmount(value)
        }}
      >
        £{displayAmount(value)}
      </button>
    );
  }

  return <div className="donate-page">
    <div className="donation-header">
      <SvgIconsLock/>
      <span>Secure Donation</span>
    </div>

  {config.enableMonthlyDonations && (
    <>
      <div className="donation-type-toggle">
        <button
          type="button"
          className={`toggle-btn ${!isMonthly ? 'active' : ''}`}
          onClick={() => setIsMonthly(false)}
        >
          <span>Give once</span>
        </button>
        <button
          type="button"
          className={`toggle-btn ${isMonthly ? 'active' : ''}`}
          onClick={() => setIsMonthly(true)}
        >
          <div className="heart-icon">
            <SvgIconsHeart />
            {animateHeart && <div className="heart-animation"><SvgIconsHeart /></div>}
          </div>
          <span>
            Monthly
          </span>
        </button>
      </div>
    </>
  )}

  {presetAmounts && presetAmounts.length > 0 && (
    <>
      <div className="amount-container">
        {presetAmounts.map((value) => (
          <AmountButton key={value} value={value} />
        ))}
      </div>
    </>
  )}

  <div className="custom-amount">
    <div className="input-group">
      <span className="currency">£</span>
      <input
        className={`custom-amount-input`}
        type="text"
        value={customInputAmount}
        onChange={handleInputChange}
        placeholder="Custom amount"
      />
    </div>
  </div>

  {config.coverFee && (isMonthly || !config.enableMonthlyUpsell || config.preTickCoverFee) &&
  <div className="cover-fee">
    <label><input type="checkbox" checked={coverFee} onChange={() => setCoverFee(!coverFee)}/><SafeRenderHtml html={coverFeeText} /></label>
  </div>
  }

    <div>
      <button
          className="donate-btn"
          type="button"
          onClick={handleSubmit}
          disabled={buttonDisabled}
        >
          {`Donate £${displayAmount(paymentAmount)}${isMonthly ? ' monthly' : ''}`}
      </button>
    </div>

    <div className='margin-top'>
      { !buttonDisabled && <ExpressButtons amountInMinorUnits={paymentAmount} isMonthly={isMonthly} coverFee={coverFee} onComplete={onComplete} stripePromise={stripePromise} /> }
    </div>

    { showDisabledMesasge && <div className='center margin-top disabled-message'>The minimum amount is £0.50</div> }
  </div>
}
